import styled from "styled-components";
import { ColorKey } from "@template/theme/types/color.type.ts";

export const LoadingSpinnerContainer = styled.div<{
  $color?: ColorKey | "white";
}>`
  position: relative;
  aspect-ratio: 1;
  box-sizing: border-box;

  &::after {
    position: absolute;
    height: 100%;
    width: 100%;
    border-radius: 50%;
    border-width: 2px;
    border-style: solid;
    ${({ theme, $color }) => {
      switch ($color) {
        case undefined:
          return `border-color: currentColor transparent transparent transparent;`;
        case "white":
          return `border-color: ${theme.colors.base} transparent transparent transparent;`;
        default:
          return `border-color: ${theme.colors[$color][500]} transparent transparent transparent;`;
      }
    }};
    content: "";
    display: block;
    animation: spin 1s linear infinite;
    left: 50;
    top: 50;
    transform: translate(-50%, -50%);

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
`;
